<template>
  <div class="row">
    <div class="col-xs-12 col-md-6">
      <div class="form-group">
        <label for="report_option_month">Report Month</label>
        <select
          id="report_option_month"
          v-model="value.month"
          class="form-control"
        >
          <option
            v-for="(month, index) in MONTHS"
            :key="`month-${index}`"
            :value="index + 1"
          >
            {{ month }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-xs-12 col-md-6">
      <div class="form-group">
        <label for="report_option_year">Report Year</label>
        <input
          id="report_option_year"
          v-model="value.year"
          type="number"
          class="form-control"
        />
      </div>
    </div>
  </div>
</template>

<script>
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default {
  props: {
    value: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      MONTHS,
    };
  },

  mounted() {
    this.$emit("loaded");
    this.$emit("completed");
  },
};
</script>
